import { freshPaintAPI } from "./client/freshpaint";
import { AWSAutocompletePrediction, AWSPlace } from "./geoService.types";
import { getPartsFromAddress1 } from "./utils";

const FPAPISuccessStatus = "ok";

type AutocompleteResponse = {
  ResultItems: AWSAutocompletePrediction[];
};

const getFPAutoCompletePredictions = (
  partialAddress: string,
  callback: (predictions: AWSAutocompletePrediction[] | null, status: string) => void,
) => {
  const NYC_CENTER = [-73.935242, 40.73061];

  const reqBody = {
    Filter: {
      IncludeCountries: ["US"],
    },
    BiasPosition: NYC_CENTER,
    Language: "en",
    MaxResults: 5,
    QueryText: partialAddress,
  };

  freshPaintAPI
    .post<AutocompleteResponse>(`/autocomplete?token=${process.env.FRESHPAINT_API_TOKEN}`, reqBody)
    .then((res) => {
      callback(res.data?.ResultItems, "ok");
    });
};

const getFPPlace = (
  placeId: string,
  callback: (placeDetails: AWSPlace, status: string) => void,
) => {
  freshPaintAPI
    .get<AWSPlace>(`/place/${placeId}?token=${process.env.FRESHPAINT_API_TOKEN}`)
    .then((res) => {
      callback(res.data, "ok");
    });
};

type ReverseGeocodeResponse = {
  ResultItems: AWSPlace[];
};

const reverseGeocode = (lng: number, lat: number, callback: (result: AWSPlace[]) => void): void => {
  const reqBody = {
    QueryPosition: [lng, lat],
    Language: "en",
  };
  freshPaintAPI
    .post<ReverseGeocodeResponse>(
      `/reverse-geocode?token=${process.env.FRESHPAINT_API_TOKEN}`,
      reqBody,
    )
    .then((res) => {
      callback(res.data.ResultItems);
    });
};

type GeocodeResponse = {
  ResultItems: AWSPlace[];
};

type geoCodeInput = {
  address1: string;
  city: string;
  state: string;
  zipCode: string;
};

const geoCode = (input: geoCodeInput, callback: (result: AWSPlace[]) => void): void => {
  const { address1, city, state, zipCode } = input;

  const { streetNumber, streetName } = getPartsFromAddress1(address1);

  const reqBody = {
    Language: "en",
    QueryComponents: {
      AddressNumber: streetNumber,
      Street: streetName,
      SubRegion: city,
      Region: state,
      PostalCode: zipCode,
      Country: "USA",
    },
  };
  freshPaintAPI
    .post<GeocodeResponse>(`/geocode?token=${process.env.FRESHPAINT_API_TOKEN}`, reqBody)
    .then((res) => {
      callback(res.data.ResultItems);
    });
};

export {
  getFPAutoCompletePredictions,
  getFPPlace,
  FPAPISuccessStatus,
  reverseGeocode,
  geoCode,
  GeocodeResponse,
};
